export const JOB_STEPS = {
    DETAILS: 1,
    OPTIONS: 2,
    STAGES: 3,
    AUTOMATIONS: 4,
    SCORECARDS: 5,
    SHARING: 6
 }  
 
export const JOB_STEPS_BACKEND = 
{
    'new':0,
    'details': 0,
    'edit':0,
    'job-options': 1,
    'stages': 2,
    'interview-stages': 2,
    'interview-details': 3,
    'scorecards':4,
    'sharing':5,
    'job-sharing':5,
}
 